import { LOGUS_CONFIG } from '../config'
import axios from 'axios'

export default {

    /*
        GET     /api/children
    */
    getChildren: function(options){
        return axios.get( LOGUS_CONFIG.API_URL + '/children',{
            params:{
                offset:options.offset,
                itemsPerPage:options.itemsPerPage,
                orderBy:options.orderBy,
                orderDirection:options.orderDirection,
                showDeleted:options.showDeleted,
                selectedYear:options.selectedYear,
                selectedCourse:options.selectedCourse,
                showWithoutCourse:options.showWithoutCourse
        }});
    },

    /*
        GET     /api/children/search
    */
   searchChildren: function(options){
    return axios.get( LOGUS_CONFIG.API_URL + '/children/search',{
        params:{
            showDeleted:options.showDeleted,
            selectedYear:options.selectedYear,
            selectedCourse:options.selectedCourse,
            showWithoutCourse:options.showWithoutCourse,
            filterableHeaders:options.filterableHeaders,
            q:options.q
    }});
},

    /*
		POST 	/api/children
	*/
    postAddNewChild: function( name,surname, birth_year,note,pickup,year_id,course_id ){
        return axios.post( LOGUS_CONFIG.API_URL + '/children',
            {
                name: name,
                surname:surname,
                birth_year:birth_year,
                note:note,
                pickup:pickup,
                year_id:year_id,
                course_id:course_id
            }
        );
    },

     /*
		POST 	/api/children/import
	*/
    postImportChildren: function( children ){
        return axios.post( LOGUS_CONFIG.API_URL + '/children/import',
            {
                children: children,
            }
        );
    },

    /*
		GET 	/api/children/{slug}/edit
	*/
    getChildEdit: function( slug, year_id ){
		return axios.get( LOGUS_CONFIG.API_URL + '/children/' + slug + '/edit/' + year_id );
    },
    
    /*
		GET 	/api/children/{slug}/owner
	*/
    getChildOwner: function( slug ){
		return axios.get( LOGUS_CONFIG.API_URL + '/children/' + slug + '/owner' );
    },
    
    /*
		GET 	/api/children/my
	*/
    getMyChildren: function(){
		return axios.get( LOGUS_CONFIG.API_URL + '/children/my');
	},

    /*
		PUT 	/api/children/{slug}
	*/
    putEditChild: function(slug, name,surname,birth_year,note,pickup,year_id,course_id){
        return axios.put( LOGUS_CONFIG.API_URL + '/children/'+ slug,
            {
                name: name,
                surname:surname,
                birth_year:birth_year,
                note:note,
                pickup:pickup,
                year_id:year_id,
                course_id:course_id
            }
        );
    },

     /*
		GET 	/api/children/reactivate/{slug}
	*/
    putReactivateChild: function(slug, year_id){
        return axios.get( LOGUS_CONFIG.API_URL + '/children/reactivate/' + slug + '/' + year_id);
    },

    /*
		DELETE /api/children/{slug}
	*/
    deleteChild: function( slug, year_id ){
		return axios.delete( LOGUS_CONFIG.API_URL + '/children/' + slug  + '/' + year_id);
    },
    
    /*
		DELETE /api/children/{slug}/force
	*/
    forceDeleteChild: function( slug, year_id ){
		return axios.delete( LOGUS_CONFIG.API_URL + '/children/' + slug + '/force/' + year_id );
    },
    
    //############################### child

    /*
		GET 	/api/children/{slug}/mobile
	*/
    getChildMobile: function( slug ){
		return axios.get( LOGUS_CONFIG.API_URL + '/children/' + slug + '/mobile');
    },

    /*
		GET 	/api/children/{slug}
	*/
    getChild: function( slug,year_id ){
		return axios.get( LOGUS_CONFIG.API_URL + '/children/' + slug + '/' + year_id );
    },

     /*
		GET 	/api/children/{card}/{year_id}/card
	*/
    getChildrenByCard: function( card,year_id ){
		return axios.get( LOGUS_CONFIG.API_URL + '/children/' + card + '/' + year_id + '/card' );
    },

     /*
		GET 	/api/children/{slug}/log
	*/
    getChildLog: function( options){
		return axios.get( LOGUS_CONFIG.API_URL + '/children/' + options.slug + '/log',{
            params:{
                fromDate:options.fromDate,
                toDate:options.toDate,
        }});
    },

     /*
		GET 	/api/children/{slug}/presence
	*/
    getChildPresence: function( options){
		return axios.get( LOGUS_CONFIG.API_URL + '/children/' + options.slug + '/presence',{
            params:{
                fromDate:options.fromDate,
                toDate:options.toDate,
        }});
    },

     /*
		GET 	/api/children/{slug}/settlements
	*/
    getChildSettlements: function( options){
		return axios.get( LOGUS_CONFIG.API_URL + '/children/' + options.slug + '/settlements',{
            params:{
                fromDate:options.fromDate,
                toDate:options.toDate,
        }});
    },

    /*
		PUT 	/api/children/{slug}/course
	*/
    putNewCourse: function(slug, course_id){
        return axios.put( LOGUS_CONFIG.API_URL + '/children/'+ slug + '/course',
            {
                course_id: course_id,
            }
        );
    },

/*
		GET 	/api/children/{slug}/rateEdit
	*/
    getEditRateData: function(slug, year_id){
        return axios.put( LOGUS_CONFIG.API_URL + '/children/'+ slug + '/rateEdit/' + year_id);
    },

    /*
		PUT 	/api/children/{slug}/rate
	*/
    putEditRate: function(slug, rate_id, document, expiry, valid_from){
        return axios.put( LOGUS_CONFIG.API_URL + '/children/'+ slug + '/rate',
            {
                rate_id: rate_id,
                document:document,
                expiry:expiry,
                valid_from:valid_from
            }
        );
    },

     /*
        GET     /api/children/searchLookup
    */
   searchChildrenLookup: function(options){
    return axios.get( LOGUS_CONFIG.API_URL + '/children/searchLookup',{
        params:{
            slug:options.slug,
            q:options.q
    }});

    },

     /*
        GET     /api/children/searchLookupSW
    */
   searchChildrenLookupSW: function(options){
    return axios.get( LOGUS_CONFIG.API_URL + '/children/searchLookupSW',{
        params:{
            q:options.q
    }});

    },

     /*
        GET     /api/children/shortCard
    */
   getChildrenShortCard: function(){
     return axios.get( LOGUS_CONFIG.API_URL + '/children/shortCard');
   },

     /*
        GET     /api/children/searchSettlementLookup
    */
   searchChildrenSettlementLookup: function(options){
    return axios.get( LOGUS_CONFIG.API_URL + '/children/searchSettlementLookup',{
        params:{
            selectedYear:options.selectedYear,
            selectedMonth:options.selectedMonth,
            q:options.q
    }});

    },
     /*
		PUT 	/api/children/{slug}/addReference
	*/
    putAddRerefence: function(slug, child_id){
        return axios.put( LOGUS_CONFIG.API_URL + '/children/'+ slug + '/addReference',
            {
                child_id: child_id,
            }
        );
    },

     /*
		PUT 	/api/children/{slug}/deleteReference
	*/
    putDeleteRerefence: function(slug, child_id){
        return axios.put( LOGUS_CONFIG.API_URL + '/children/'+ slug + '/deleteReference',
            {
                child_id: child_id,
            }
        );
    },
     /*
		PUT 	/api/children/{slug}/addNote
	*/
    putAddNote: function(slug, note){
        return axios.put( LOGUS_CONFIG.API_URL + '/children/'+ slug + '/addNote',
            {
                note: note,
            }
        );
    },

     /*
		PUT 	/api/children/{slug}/addDietNote
	*/
    putAddDietNote: function(slug,diet, diet_note){
        return axios.put( LOGUS_CONFIG.API_URL + '/children/'+ slug + '/addDietNote',
            {   
                diet:diet,
                diet_note: diet_note,
            }
        );
    },

      /*
		PUT 	/api/children/{slug}/addImage
	*/
    putAddImage: function(slug, input_img){
        return axios.put( LOGUS_CONFIG.API_URL + '/children/'+ slug + '/addImage',
            {
                input_img: input_img,
            }
        );
    },

}